module.exports = __webpack_public_path__ + "img/luoye.22fb69b9.png";